// 🍪 Lean Cookie-Handler - Single Source of Truth für Discount Codes
// WICHTIG: Cookie ist IMMER die Quelle der Wahrheit - Cart wird synchronisiert

(function() {
  'use strict';
  
  const DISCOUNT_COOKIE_NAME = 'discount_code';
  const COOKIE_REGEX = new RegExp('(?:^|;\\s*)' + DISCOUNT_COOKIE_NAME + '=([^;]*)');
  let isProcessing = false;
  let hasInitialized = false;

  // 🔧 Hilfsfunktionen
  function getCookieValue(name) {
    try {
      const match = document.cookie.match(COOKIE_REGEX);
      if (!match) return null;
      return decodeURIComponent(match[1]);
    } catch {
      return null;
    }
  }

  function setCookie(code, force = false) {
    // WICHTIG: Nur Code-Input darf REMOVE setzen, nicht automatisch!
    const normalizedCode = code ? code.toUpperCase() : null;
    
    // Nur setzen wenn es ein echter Code ist ODER explizit REMOVE vom Code-Input
    if (!normalizedCode) {
      return;
    }
    
    // REMOVE nur erlauben wenn force=true (vom Code-Input)
    if (normalizedCode === 'REMOVE' && !force) {
      return;
    }
    
    const cookieValue = normalizedCode;
    
    document.cookie = `${DISCOUNT_COOKIE_NAME}=${encodeURIComponent(cookieValue)}; path=/; max-age=86400; SameSite=Lax`;
    
    // Event für UI-Updates
    window.dispatchEvent(new CustomEvent('cookie:discount:change', { 
      detail: { code: normalizedCode === 'REMOVE' ? null : normalizedCode } 
    }));

    // 🧠 Cart Configuration synchronisieren
    if (window.RosentalDiscount?.syncCartConfiguration) {
      window.RosentalDiscount.syncCartConfiguration();
    }
    
    // 🚀 SOFORTIGE ANWENDUNG FÜR NEUE CODES (nicht für REMOVE)
    if (normalizedCode && normalizedCode !== 'REMOVE') {
      setTimeout(() => {
        applyCookieToCart();
      }, 200);
    }
  }

  function getActiveCode() {
    const raw = getCookieValue(DISCOUNT_COOKIE_NAME);
    if (!raw || raw === 'REMOVE') return null;
    return raw.toUpperCase();
  }

  // 🚀 WICHTIG: Cookie-Code im Cart applizieren (nicht umgekehrt!)
  async function applyCookieToCart() {
    if (isProcessing) return;
    isProcessing = true;
    
    try {
      const cookieCode = getActiveCode();
      if (!cookieCode) {
        isProcessing = false;
        return;
      }

      // 🚀 Zentrale Cart-Request über RosentalDiscount (mit Loop-Schutz)
      const cart = await window.RosentalDiscount?.fetchCartData?.(true);
      
      if (!cart) {
        isProcessing = false;
        return;
      }

      // Prüfe ob Code bereits im Cart ist
      const cartCode = cart.discount_codes
        ?.find(dc => dc.applicable !== false)
        ?.code?.toUpperCase();
      
      if (cartCode === cookieCode) {
        isProcessing = false;
        return;
      }

      // 🚀 Code im Cart applizieren (über RosentalDiscount Fetch Interceptor)
      
      // 🧠 ECHTER CART UPDATE - ÜBER ROSENTALDISCOUNT INTERCEPTOR!
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: cookieCode })
        });
        
        if (response.ok) {
          const updatedCart = await response.json();
          
          // 🧠 ROSENTALDISCOUNT SYNCHRONISIEREN
          if (window.RosentalDiscount?.syncCartConfiguration) {
            window.RosentalDiscount.syncCartConfiguration();
          }
          
          // Cart-Event auslösen für UI-Updates
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }, 100);
        } else {
        }
      } catch (error) {
      }
      
    } catch (error) {
    } finally {
      isProcessing = false;
    }
  }

  // 🚀 Initial Cookie Check (wird beim Laden ausgeführt)
  function checkInitialCookie() {
    const existingCode = getActiveCode();
    if (existingCode) {
      // WICHTIG: Cookie-Code sofort im Cart applizieren
      setTimeout(() => {
        applyCookieToCart();
      }, 100);
    }
  }

  // 🎯 Event-Listener für Cart-Events (nur für UI-Updates, nicht für Sync)
  function initializeEventListeners() {
    // 🚫 KEINE Cart-Events mehr - verursachen Loops!
    // Cart-Events werden von rosental-discount.js gehandhabt
  }

  function isKnownCode(code) {
    if (!code) return false;
    const normalized = code.toUpperCase();
    const discounts = window.themeDiscounts || [];
    if (!Array.isArray(discounts)) return false;
    return discounts.some(d => {
      if (Array.isArray(d?.codes)) {
        return d.codes.some(c => String(c || '').trim().toUpperCase() === normalized);
      }
      const dc = String(d?.code || '').trim().toUpperCase();
      return dc && dc === normalized;
    });
  }

  // 🚀 Initialisierung
  function initialize() {
    if (hasInitialized) return;

    // Unbekannte Codes (z.B. von /discount/CODE URLs) in sessionStorage parken
    const existingCode = getActiveCode();
    if (existingCode && !isKnownCode(existingCode)) {
      sessionStorage.setItem('pending_discount_code', existingCode);
      sessionStorage.removeItem('pending_code_validated');
      document.cookie = `${DISCOUNT_COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax`;
    }

    // 1. Prüfe ob bereits ein Cookie existiert und appliziere ihn
    checkInitialCookie();
    
    // 2. Event-Listener initialisieren
    initializeEventListeners();
    
    hasInitialized = true;
  }

  // 🎯 Public API
  window.CookieHandler = {
    getActiveCode,
    setCookie,
    getCookieValue,
    applyCookieToCart, // Neue Funktion
    initialize
  };

  // 🚀 Auto-Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();